<template>
  <div class="list__action__item" v-if="actionLog">
    <div>
      <div class="avatar-fake margin-right-10 flex-row flex__center">
        <span>{{ buildShortName(actionLog.creatorName) }}</span>
      </div>
    </div>
    <div class="list__action__item--content">
      <div class="flex-row flex__between">
        <p class="name margin-0">
          {{ actionLog.creatorName }}
        </p>
        <div class="time font-size__small">
          <i class="fal fa-clock">
            {{ actionLog.createTime | convertToLabelFilter }}
          </i>
        </div>
      </div>
      <div>
        <p :class="['action-type flex-row flex__left inline-flex']">
          <slot name="actionName"></slot>
        </p>
        <div
          v-if="actionLog.comment"
          class="content__message--text content__message--item"
        >
          <el-input
            type="textarea"
            resize="none"
            ref="inputComment"
            autosize
            v-model="actionLog.comment"
            disabled
            class="input-display__comment style-fullWidth input-none__border bg__transparent"
          ></el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import convertToLabelFilter from "../../../filters/convertToLabelFilter";
import utils from "../../../services/utils";
import hanhChinhUtils from "../../../services/hanhChinhUtils";

export default {
  name: "action-log-template",
  props: ["actionLog"],
  filters: {
    convertToLabelFilter
  },
  data() {
    return {
      actionNameLabel: null
    };
  },
  created() {
    this.actionNameLabel = hanhChinhUtils.getActionLogActionNameLabel(
      this.actionLog.actionName
    );
  },
  methods: {
    buildShortName(fullName) {
      return utils.buildShortName(fullName);
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/action-log-template.vue